// extracted by mini-css-extract-plugin
export default {"statistics-container-vicri":"NationalViCRIBlock_statistics-container-vicri__cfJ1i"};